import React from "react";
import styles from "./Partners.module.css";

const partners = [
  {
    name: "Ethiopian ICT Park",
    logo: require("../assets/img/ethiopian_ict_park _logo.png"),
    delay: "100"
  },
  {
    name: "St. Mary’s University",
    logo: require("../assets/img/smu.jpg"),
    delay: "300"
  },
  {
    name: "ASTU (Addis Ababa Science and Technology University)",
    logo: require("../assets/img/ASTU_logo.jpg"),
    delay: "500"
  },
  {
    name: "FDRE Technical and Vocational Institute",
    logo: require("../assets/img/TVTI_HD_LOGO.png"),
    delay: "700"
  }
];

const Partners = () => {
  return (
    <div className="container-fluid py-5 bg-white">
      <div className="container py-5">
        <div className="text-center mb-5" data-aos="fade-up" data-aos-delay="100">
          <h5 className="sub-title" style={{ color: "#A71717" }}>OUR PARTNERS</h5>
          <h1 className="display-5 mb-3" style={{ color: "#A71717" }}>Trusted by Leading Organizations</h1>
          <p className="text-muted">
            We collaborate with industry leaders and innovative organizations across Ethiopia and beyond.
          </p>
        </div>

        <div className="row g-4 justify-content-center align-items-center">
          {partners.map((partner, i) => (
            <div className="col-12 col-md-6 col-lg-4 text-center" data-aos="fade-up" data-aos-delay={partner.delay} key={i}>
              <div className={styles["partner-card"]}>
                <img src={partner.logo} alt={partner.name} className={styles["partner-logo"]} />
                <h6 className={styles["partner-title"]}>{partner.name}</h6>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Partners;
